import { EnumMbaProductType } from '../../../upload/app-constants';
import { EnumAmazonMarketplace, EnumAmazonProduct } from './amazon.constants';


/**------------------------------------------------------
 * Amazon Product Specifications
 */
export const AMAZON_PRODUCT_SPECIFICATION: IAmazonProduct[] = [

	// Shirt --------------------
	{
		code			: EnumAmazonProduct.Shirt,
		marketplaces: [EnumAmazonMarketplace.COM, EnumAmazonMarketplace.CO_UK, EnumAmazonMarketplace.DE, EnumAmazonMarketplace.FR, EnumAmazonMarketplace.IT, EnumAmazonMarketplace.ES, EnumAmazonMarketplace.JP],
		name			: 'Standard Shirt',
		nameShort		: 'Standard Shirt',
		productType		: EnumMbaProductType.Clothing
	},

	// Premium Shirt ------------
	{
		code			: EnumAmazonProduct.PremiumShirt,
		marketplaces: [EnumAmazonMarketplace.COM, EnumAmazonMarketplace.CO_UK, EnumAmazonMarketplace.DE, EnumAmazonMarketplace.FR, EnumAmazonMarketplace.IT, EnumAmazonMarketplace.ES],
		name			: 'Premium Shirt',
		nameShort		: 'Premium Shirt',
		productType		: EnumMbaProductType.Clothing
	},

	// VNeck --------------------
	{
		code			: EnumAmazonProduct.VNeck,
		marketplaces: [EnumAmazonMarketplace.COM, EnumAmazonMarketplace.CO_UK, EnumAmazonMarketplace.DE, EnumAmazonMarketplace.FR, EnumAmazonMarketplace.IT, EnumAmazonMarketplace.ES],
		name			: 'V-Neck',
		nameShort		: 'V-Neck',
		productType		: EnumMbaProductType.Clothing
	},

	// Tank Top -----------------
	{
		code			: EnumAmazonProduct.TankTop,
		marketplaces: [EnumAmazonMarketplace.COM, EnumAmazonMarketplace.CO_UK, EnumAmazonMarketplace.DE, EnumAmazonMarketplace.FR, EnumAmazonMarketplace.IT, EnumAmazonMarketplace.ES],
		name			: 'Tank Top',
		nameShort		: 'Tank Top',
		productType		: EnumMbaProductType.Clothing
	},

	// Long Sleeve --------------
	{
		code			: EnumAmazonProduct.LongSleeve,
		marketplaces: [EnumAmazonMarketplace.COM, EnumAmazonMarketplace.CO_UK, EnumAmazonMarketplace.DE, EnumAmazonMarketplace.FR, EnumAmazonMarketplace.IT, EnumAmazonMarketplace.ES, EnumAmazonMarketplace.JP],
		name			: 'Long Sleeve',
		nameShort		: 'Long Sleeve',
		productType		: EnumMbaProductType.Clothing
	},

	// Raglan -------------------
	{
		code			: EnumAmazonProduct.Raglan,
		marketplaces: [EnumAmazonMarketplace.COM, EnumAmazonMarketplace.CO_UK, EnumAmazonMarketplace.DE, EnumAmazonMarketplace.FR, EnumAmazonMarketplace.IT, EnumAmazonMarketplace.ES],
		name			: 'Raglan',
		nameShort		: 'Raglan',
		productType		: EnumMbaProductType.Clothing
	},

	// Sweatshirt ---------------
	{
		code			: EnumAmazonProduct.Sweatshirt,
		marketplaces: [EnumAmazonMarketplace.COM, EnumAmazonMarketplace.CO_UK, EnumAmazonMarketplace.DE, EnumAmazonMarketplace.FR, EnumAmazonMarketplace.IT, EnumAmazonMarketplace.ES, EnumAmazonMarketplace.JP],
		name			: 'Sweatshirt',
		nameShort		: 'Sweatshirt',
		productType		: EnumMbaProductType.Clothing
	},

	// Hoodie -------------------
	{
		code			: EnumAmazonProduct.Hoodie,
		marketplaces: [EnumAmazonMarketplace.COM, EnumAmazonMarketplace.CO_UK, EnumAmazonMarketplace.DE, EnumAmazonMarketplace.FR, EnumAmazonMarketplace.IT, EnumAmazonMarketplace.ES, EnumAmazonMarketplace.JP],
		name			: 'Hoodie',
		nameShort		: 'Hoodie',
		productType		: EnumMbaProductType.Clothing
	},

	// Pop Socket ---------------
	{
		code			: EnumAmazonProduct.PopSocket,
		marketplaces: [EnumAmazonMarketplace.COM, EnumAmazonMarketplace.CO_UK, EnumAmazonMarketplace.DE, EnumAmazonMarketplace.FR, EnumAmazonMarketplace.IT, EnumAmazonMarketplace.ES],
		name			: 'PopSockets Grip',
		nameShort		: 'PopSockets Grip',
		productType		: EnumMbaProductType.Accessory
	},

	// Phone Case ---------------
	{
		code			: EnumAmazonProduct.PhoneCase,
		marketplaces: [EnumAmazonMarketplace.COM, EnumAmazonMarketplace.CO_UK, EnumAmazonMarketplace.DE, EnumAmazonMarketplace.FR, EnumAmazonMarketplace.IT, EnumAmazonMarketplace.ES, EnumAmazonMarketplace.JP],
		name			: 'Phone Cases',
		nameShort		: 'Phone Cases',
		productType		: EnumMbaProductType.Accessory
	},

	// Tote Bag -----------------
	{
		code			: EnumAmazonProduct.ToteBag,
		marketplaces: [EnumAmazonMarketplace.COM],
		name			: 'Tote Bag',
		nameShort		: 'Tote Bag',
		productType		: EnumMbaProductType.Accessory
	},

	// Throw Pillow -------------
	{
		code			: EnumAmazonProduct.ThrowPillow,
		marketplaces: [EnumAmazonMarketplace.COM],
		name			: 'Throw Pillows',
		nameShort		: 'Throw Pillows',
		productType		: EnumMbaProductType.Accessory
	},

	// Tumbler -------------
	{
		code			: EnumAmazonProduct.Tumbler,
		marketplaces: [EnumAmazonMarketplace.COM, EnumAmazonMarketplace.CO_UK, EnumAmazonMarketplace.DE, EnumAmazonMarketplace.FR, EnumAmazonMarketplace.IT, EnumAmazonMarketplace.ES],
		name			: 'Tumbler',
		nameShort		: 'Tumbler',
		productType		: EnumMbaProductType.Accessory
	},

	// Ceramic Mug -------------
	{
		code			: EnumAmazonProduct.CeramicMug,
		marketplaces: [EnumAmazonMarketplace.COM],
		name			: 'Ceramic Mug',
		nameShort		: 'Ceramic Mug',
		productType		: EnumMbaProductType.Accessory
	},
	{
		code: EnumAmazonProduct.ComfortColorsHeavyweightTShirt,
		name: 'Comfort Colors Heavyweight T-Shirt',
		nameShort: 'Heavyweight T-Shirt',
		productType: EnumMbaProductType.Clothing,
		marketplaces: [EnumAmazonMarketplace.COM, EnumAmazonMarketplace.CO_UK, EnumAmazonMarketplace.DE, EnumAmazonMarketplace.FR, EnumAmazonMarketplace.IT, EnumAmazonMarketplace.ES]
	},
	{
		code: EnumAmazonProduct.PerformanceShirt,
		name: 'Performance T-Shirt',
		nameShort: 'Performance T-Shirt',
		productType: EnumMbaProductType.Clothing,
		marketplaces: [EnumAmazonMarketplace.COM, EnumAmazonMarketplace.JP]
	},
	{
		code: EnumAmazonProduct.ComfortColorsSweatshirt,
		name: 'Comfort Colors Sweatshirt',
		nameShort: 'Comfort Colors Sweatshirt',
		productType: EnumMbaProductType.Clothing,
		marketplaces: [EnumAmazonMarketplace.COM]
	},
	{
		code: EnumAmazonProduct.ComfortColorsCropSweatshirt,
		name: 'Comfort Colors Crop Sweatshirt',
		nameShort: 'Comfort Colors Crop Sweatshirt',
		productType: EnumMbaProductType.Clothing,
		marketplaces: [EnumAmazonMarketplace.COM]
	},
	{
		code: EnumAmazonProduct.CropTop,
		name: 'Crop Top',
		nameShort: 'Crop Top',
		productType: EnumMbaProductType.Clothing,
		marketplaces: [EnumAmazonMarketplace.COM]
	},
	{
		code: EnumAmazonProduct.ZipHoodie,
		name: 'Zip Hoodie',
		nameShort: 'Zip Hoodie',
		productType: EnumMbaProductType.Clothing,
		marketplaces: [EnumAmazonMarketplace.COM, EnumAmazonMarketplace.CO_UK, EnumAmazonMarketplace.DE, EnumAmazonMarketplace.FR, EnumAmazonMarketplace.IT, EnumAmazonMarketplace.ES, EnumAmazonMarketplace.JP]
	},
	{
		code: EnumAmazonProduct.PerformanceHoodie,
		name: 'Performance Hoodie',
		nameShort: 'Performance Hoodie',
		productType: EnumMbaProductType.Clothing,
		marketplaces: [EnumAmazonMarketplace.COM]
	},
	{
		code: EnumAmazonProduct.PerformancePolo,
		name: 'Performance Polo',
		nameShort: 'Performance Polo',
		productType: EnumMbaProductType.Clothing,
		marketplaces: [EnumAmazonMarketplace.COM]
	},
	{
		code: EnumAmazonProduct.PerformanceQuarterZip,
		name: 'Performance Quarter-Zip',
		nameShort: 'Quarter-Zip',
		productType: EnumMbaProductType.Clothing,
		marketplaces: [EnumAmazonMarketplace.COM]
	},
	{
		code: EnumAmazonProduct.BaseballHat,
		name: 'Baseball Hat',
		nameShort: 'Baseball Hat',
		productType: EnumMbaProductType.Clothing,
		marketplaces: [EnumAmazonMarketplace.COM]
	},
	{
		code: EnumAmazonProduct.TruckerHat,
		name: 'Trucker Hat',
		nameShort: 'Trucker Hat',
		productType: EnumMbaProductType.Clothing,
		marketplaces: [EnumAmazonMarketplace.COM]
	},
	{
		code: EnumAmazonProduct.SportSunVisor,
		name: 'Sport Sun Visor',
		nameShort: 'Sun Visor',
		productType: EnumMbaProductType.Clothing,
		marketplaces: [EnumAmazonMarketplace.COM]
	},
	{
		code: EnumAmazonProduct.SportBackpack,
		name: 'Sport Backpack',
		nameShort: 'Sport Backpack',
		productType: EnumMbaProductType.Accessory,
		marketplaces: [EnumAmazonMarketplace.COM]
	},
	{
		code: EnumAmazonProduct.LaptopSleeve,
		name: 'Laptop Sleeve',
		nameShort: 'Laptop Sleeve',
		productType: EnumMbaProductType.Accessory,
		marketplaces: [EnumAmazonMarketplace.COM]
	},
	{
		code: EnumAmazonProduct.MousePad,
		name: 'Mouse Pad',
		nameShort: 'Mouse Pad',
		productType: EnumMbaProductType.Accessory,
		marketplaces: [EnumAmazonMarketplace.COM]
	},
	{
		code: EnumAmazonProduct.ThrowBlanket,
		name: 'Throw Blanket',
		nameShort: 'Throw Blanket',
		productType: EnumMbaProductType.Accessory,
		marketplaces: [EnumAmazonMarketplace.COM]
	},
	{
		code: EnumAmazonProduct.UnframedPoster,
		name: 'Unframed Poster',
		nameShort: 'Unframed Poster',
		productType: EnumMbaProductType.Accessory,
		marketplaces: [EnumAmazonMarketplace.COM]
	},
	{
		code: EnumAmazonProduct.TravelTumbler,
		name: 'Stainless Steel Travel Tumbler',
		nameShort: 'Travel Tumbler',
		productType: EnumMbaProductType.Accessory,
		marketplaces: [EnumAmazonMarketplace.COM]
	},
	{
		code: EnumAmazonProduct.WaterBottle,
		name: 'Water Bottle',
		nameShort: 'Water Bottle',
		productType: EnumMbaProductType.Accessory,
		marketplaces: [EnumAmazonMarketplace.COM, EnumAmazonMarketplace.CO_UK, EnumAmazonMarketplace.DE, EnumAmazonMarketplace.FR, EnumAmazonMarketplace.IT, EnumAmazonMarketplace.ES]
	},
	{
		code: EnumAmazonProduct.HardcoverJournal,
		name: 'Hardcover Journal',
		nameShort: 'Hardcover Journal',
		productType: EnumMbaProductType.Accessory,
		marketplaces: [EnumAmazonMarketplace.COM]
	},
	{
		code: EnumAmazonProduct.RetractablePen,
		name: '12-Pack Retractable Pens',
		nameShort: 'Retractable Pens',
		productType: EnumMbaProductType.Accessory,
		marketplaces: [EnumAmazonMarketplace.COM]
	}
];


//** Interfaces --------------------------------- */
export interface IAmazonProduct {
	marketplaces	?: EnumAmazonMarketplace[];
	code			: EnumAmazonProduct;
	name			: string;
	nameShort		: string;
	productType		: EnumMbaProductType;
}
